import { render, staticRenderFns } from "./successPayu.vue?vue&type=template&id=49826f7a&scoped=true&"
import script from "./successPayu.vue?vue&type=script&lang=js&"
export * from "./successPayu.vue?vue&type=script&lang=js&"
import style0 from "./successPayu.vue?vue&type=style&index=0&id=49826f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49826f7a",
  null
  
)

component.options.__file = "successPayu.vue"
export default component.exports